module.exports = __webpack_public_path__ + "img/carga.a6607cca.svg";